export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative pt-28 pb-12 border-t border-white/10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-12 mb-20">
          <div className="md:col-span-1">
            <div className="font-serif-display text-2xl text-white">
              LEO <span className="text-amber-500">BIANCHI</span>
            </div>
            <p className="mt-4 text-zinc-400 text-sm max-w-xs">
              Smart Money investing mentorship. Build a real portfolio, beat
              the index, and stop letting the bank get rich off your savings.
            </p>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-zinc-500 mb-4">
              Navigate
            </div>
            <ul className="space-y-3 text-zinc-300 text-sm">
              <li><a href="#about" className="hover:text-amber-400">About Leo</a></li>
              <li><a href="#services" className="hover:text-amber-400">Services</a></li>
              <li><a href="#results" className="hover:text-amber-400">Track Record</a></li>
              <li><a href="#insights" className="hover:text-amber-400">Insights</a></li>
              <li><a href="#book" className="hover:text-amber-400">Book a Call</a></li>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-zinc-500 mb-4">
              Legal · Disclaimer
            </div>
            <p className="text-zinc-500 text-xs leading-relaxed">
              Investing involves risk, including possible loss of principal.
              Past performance is not indicative of future results. Nothing on
              this site is financial advice — it's education and mentorship to
              help you make informed decisions yourself.
            </p>
          </div>
        </div>

        <div className="relative">
          <div className="font-serif-display text-white/[0.04] text-[18vw] leading-none tracking-tighter text-center select-none pointer-events-none">
            BIANCHI
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8 border-t border-white/5 text-xs text-zinc-500">
          <div data-testid="footer-copyright">
            © {new Date().getFullYear()} Leo Bianchi Trading. All rights reserved.
          </div>
          <div className="flex gap-6">
            <a href="#" className="hover:text-amber-400">Privacy</a>
            <a href="#" className="hover:text-amber-400">Terms</a>
            <a href="#" className="hover:text-amber-400">Risk Disclosure</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
